import styled from 'styled-components'

export const Wrapper = styled.div`
  span {
    display: block;
    margin-bottom: 16px;
  }
`
